import script from "./PaymentDetailsPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentDetailsPopup.vue?vue&type=script&setup=true&lang=js"

import "./PaymentDetailsPopup.vue?vue&type=style&index=0&id=1fb4da64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fb4da64"]])

export default __exports__